// Class-string builder for popover / dropdown / sidebar-list row affordances.
// Lives separately from <MenuItem> for the same reason buttonClasses() lives
// in its own file: components/design/MenuItem.tsx must export only React
// components, otherwise Vite's fast-refresh stops re-rendering MenuItem
// cleanly (react-refresh/only-export-components).
//
// Use this helper directly when the consumer is NOT a <button> — typically a
// <Link> / <NavLink> that needs to render with the same chrome:
//
//   import { Link } from "react-router";
//   import { menuItemClasses } from "@/components/design/menu-item-classes";
//
//   <Link to="/foo" className={menuItemClasses({ active: isFoo })}>Foo</Link>
//
// For <button>-shaped consumers, prefer the <MenuItem> component.

interface MenuItemClassesOptions {
  active?: boolean;
  hasTrailing?: boolean;
  className?: string;
}

const BASE =
  "flex w-full items-center gap-2 rounded-md px-2 py-2 text-left text-[13px] text-ink/70 transition hover:bg-ink/[0.06] hover:text-ink disabled:opacity-60";

export function menuItemClasses({
  active = false,
  hasTrailing = false,
  className = "",
}: MenuItemClassesOptions = {}): string {
  return [
    BASE,
    hasTrailing ? "justify-between" : "",
    active ? "bg-ink/[0.06] text-ink" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
}
